// extracted by mini-css-extract-plugin
module.exports = {"messageLink":"Messages_messageLink__3K4Wm","attachmentIcon":"Messages_attachmentIcon__2vp6Z"};